import { Carousel, Image } from "antd";
import React from "react";

const DEFAULT_PLACEHOLDER_SRC = "/images/listing-placeholder.svg";

const carouselStyle: React.CSSProperties = {
  background: "#f0f2f5",
  borderRadius: 8,
  overflow: "hidden",
};

const defaultImageStyle: React.CSSProperties = {
  height: 320,
  objectFit: "cover",
  width: "100%",
  display: "block",
};

export type CoverImageGalleryProps = {
  imageUrls: string[];
  /** Used for image alt text and carousel slide labels. */
  title: string;
  placeholderSrc?: string;
  imageHeight?: number;
};

export function CoverImageGallery({
  imageUrls,
  title,
  placeholderSrc = DEFAULT_PLACEHOLDER_SRC,
  imageHeight = 320,
}: CoverImageGalleryProps) {
  const imageStyle: React.CSSProperties = {
    ...defaultImageStyle,
    height: imageHeight,
  };

  const urls = imageUrls.length > 0 ? imageUrls : [placeholderSrc];

  if (urls.length === 1) {
    return (
      <div style={carouselStyle}>
        <img
          alt={title}
          src={urls[0]}
          style={imageStyle}
          onError={(event) => {
            event.currentTarget.src = placeholderSrc;
          }}
        />
      </div>
    );
  }

  return (
    <Carousel autoplay dots style={carouselStyle}>
      {urls.map((url, index) => (
        <div key={`${url}-${index}`}>
          <Image
            alt={`${title} ${index + 1}`}
            src={url}
            style={imageStyle}
            preview
            fallback={placeholderSrc}
          />
        </div>
      ))}
    </Carousel>
  );
}
